export default __webpack_public_path__ + "static/media/mobile2.ff56f03c.png";